import { Button, Stack, Typography } from "@mui/material";
import {
  CalendarMonth,
  CheckCircle,
  AccessTime,
  MedicalServices,
  People,
} from "@mui/icons-material";
import type { ReactNode } from "react";

interface IProps {
  selectedView: string;
  onSelectView: (view: string) => void;
  cards: any[];
  /** CTA extra renderizado depois do último card (ex.: Evolução ao lado do FluxZap). */
  endAction?: ReactNode;
}

export function ScheduleSelectionCards({
  selectedView,
  onSelectView,
  cards,
  endAction,
}: IProps) {
  return (
    <Stack spacing={1} direction="row" width="100%" flexWrap="wrap" useFlexGap>
      {cards.map((card) => {
        const Icon = card.icon;
        const isSelected = selectedView === card.id;

        return (
          <Button
            key={card.id}
            onClick={() => onSelectView(card.id)}
            variant={isSelected ? "contained" : "text"}
            sx={{
              justifyContent: "flex-start",
              py: 1.5,
              px: 2,
              textTransform: "none",
              borderRadius: 1,
              color: isSelected ? "white" : "text.primary",
            }}
            startIcon={
              <Icon
                sx={{
                  fontSize: 20,
                  color: isSelected ? "white" : "primary.main",
                }}
              />
            }
          >
            <Typography variant="body1" fontWeight={isSelected ? 500 : 400}>
              {card.title}
            </Typography>
          </Button>
        );
      })}
      {endAction}
    </Stack>
  );
}
